export enum FILTRES_HISTORIQUE_DEP_MAN {
	ID = '@id',
	FICHIER_INTEGRE = 'fichier_integre',
	TYPE = 'type',
	PAGE = 'page'
}